import { PDFReports } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

export const CreateReport = Simple({
  id: '96ea1764-b491-4000-90a8-0a034c66caf1',
  object: 'Single Report',
  action: 'Create',
  page: PDFReports,
})
